import { Link } from 'react-router-dom';
import { Globe, MessageCircle, X, Share2, MapPin, Mail, Phone } from 'lucide-react';
import logoEtcs from '../../assets/logo_etcs.png';

const Footer = () => {
  return (
    <footer className="pt-16 pb-8 relative z-10" style={{ background: 'var(--bg-surface)', borderTop: '1px solid var(--border)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="mb-6">
              <Link to="/" className="inline-block">
                <img 
                  src={logoEtcs} 
                  alt="ETCS - Entre Techno Com Services" 
                  className="h-28 sm:h-32 w-auto object-contain -my-8 md:-my-10" 
                />
              </Link>
            </div>
            <p style={{ color: 'var(--text-secondary)' }} className="max-w-sm mb-6">
              Entre Techno Com Services (ETCS) est votre partenaire de confiance pour des infrastructures réseaux, télécoms et des solutions technologiques performantes au Sénégal.
            </p>
            <div className="flex gap-4">
              {[
                { icon: Share2, href: "https://linkedin.com/company/etcs-sn", label: "LinkedIn" },
                { icon: MessageCircle, href: "https://wa.me/221777000000", label: "WhatsApp" },
                { icon: Globe, href: "https://etcs-sn.com", label: "Site Web" },
                { icon: X, href: "https://x.com/etcs_sn", label: "X (Twitter)" },
              ].map((social, i) => (
                <a key={i} href={social.href} target="_blank" rel="noopener noreferrer" 
                  aria-label={`Suivez-nous sur ${social.label}`}
                  className="w-9 h-9 rounded-lg flex items-center justify-center transition-all hover:-translate-y-1" 
                  style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text-secondary)' }}>
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-bold mb-6 text-sm uppercase tracking-widest" style={{ color: 'var(--text-primary)' }}>Expertises</h4>
            <ul className="space-y-3">
              {[
                { name: "Réseaux & Télécom", path: "/reseaux" },
                { name: "Boutique IT", path: "/boutique" },
                { name: "Tous les services", path: "/services" },
                { name: "Contact", path: "/contact" },
                { name: "À Propos", path: "/a-propos" },
              ].map((l) => (
                <li key={l.name}>
                  <Link to={l.path} className="text-sm transition-colors hover:text-[#3f782b]" style={{ color: 'var(--text-secondary)' }}>{l.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-6 text-sm uppercase tracking-widest" style={{ color: 'var(--text-primary)' }}>Contact</h4>
            <ul className="space-y-4">
              <li className="flex gap-3 text-sm" style={{ color: 'var(--text-secondary)' }}>
                <MapPin size={18} className="text-[#3f782b] flex-shrink-0" />
                Dakar, Sénégal, Zone de Captage
              </li>
              <li className="flex gap-3 text-sm" style={{ color: 'var(--text-secondary)' }}>
                <Mail size={18} className="text-[#3f782b] flex-shrink-0" />
                contact@etcs-sn.com
              </li>
              <li className="flex gap-3 text-sm" style={{ color: 'var(--text-secondary)' }}>
                <Phone size={18} className="text-[#3f782b] flex-shrink-0" />
                +221 33 800 00 00
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4" style={{ borderTop: '1px solid var(--border)' }}>
          <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>
            &copy; {new Date().getFullYear()} Entre Techno Com Services. Tous droits réservés.
          </p>

          <p className="text-xs" style={{ color: 'var(--text-secondary)', opacity: 0.8 }}>
            Design & Code by{' '}
            <a 
              href="https://linktr.ee/chk_4.0.4" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-medium transition-colors hover:text-[#3f782b]"
              style={{ color: 'var(--text-primary)' }}
            >
              CHK404
            </a>
          </p>

          <div className="flex gap-6">
            <Link to="/contact" className="text-xs transition-colors hover:text-[#3f782b]" style={{ color: 'var(--text-secondary)' }}>Mentions Légales</Link>
            <Link to="/contact" className="text-xs transition-colors hover:text-[#3f782b]" style={{ color: 'var(--text-secondary)' }}>Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
